import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Personas que se sienten "infladas" permanentemente, incluso si no han comido mucho.', 'Adultos que sufren de fatiga matutina y rigidez articular al despertar.', 'Mujeres que han notado que su digestión se ha vuelto lenta y dolorosa en los últimos años.', 'Cualquiera que necesite resultados visibles y rápidos para una ocasión especial o para recuperar su bienestar.'];
const notForWho = ['Personas que buscan una solución mágica para perder 10kg de grasa en una semana.', 'Individuos con trastornos de la conducta alimentaria bajo tratamiento médico.', 'Personas que no están dispuestas a seguir instrucciones exactas durante 72 horas.'];
export function AudienceSection() {
  return <section className="py-24 bg-mint/20" data-id="element-12">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-14">
          <FadeIn direction="right" data-id="element-15">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-sage h-full" data-id="element-16">
              <h3 className="text-2xl font-bold text-forest mb-8 flex items-center gap-3" data-id="element-17">
                <CheckCircle2 className="text-sage w-8 h-8" data-id="element-18" />
                Este protocolo ES para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-19">
                {forWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-20">
                    <div className="w-2 h-2 rounded-full bg-sage mt-2.5 flex-shrink-0" data-id="element-21"></div>
                    <span className="text-gray-700 leading-relaxed" data-id="element-22">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-23">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-red-300 h-full" data-id="element-24">
              <h3 className="text-2xl font-bold text-gray-800 mb-8 flex items-center gap-3" data-id="element-25">
                <XCircle className="text-red-400 w-8 h-8" data-id="element-26" />
                Este protocolo NO es para ti si:
              </h3>
              <ul className="space-y-6" data-id="element-27">
                {notForWho.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-28">
                    <div className="w-2 h-2 rounded-full bg-red-300 mt-2.5 flex-shrink-0" data-id="element-29"></div>
                    <span className="text-gray-600 leading-relaxed" data-id="element-30">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}